

import React from 'react'
import services from '@services/services'
import { Card, Col, Row, Spin } from 'antd'
import { zoomLevel, screenType, mobileZoom, errorFatalModal } from './Utils/settings'
import { main, card_style, inner_div_style, title_style, count_style, load_style, error_wrap, triangle } from './styles.scss'

class UserServiceDashboard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            screenHeight: window.innerHeight,
            zoomLevel: '100%',
            loading: false,
            mainData: [],
            summary: [],
            screenType: screenType(),
            intervalId: null,
            errorWrap: false
        }
    }

    componentDidMount() {
        this.getData()
        window.addEventListener('resize', this.updateZoomLevel)
        this.updateZoomLevel()
        this.setState({
            intervalId: setInterval(() => {
                this.getData()
            }, 300000)
        })
    }

    componentDidUpdate(prevProps, { screenHeight }) {
        if (screenHeight !== window.innerHeight) this.setState({ screenHeight: window.innerHeight })
        if (screenHeight !== this.state.screenHeight) this.updateZoomLevel()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateZoomLevel)
        window.removeEventListener('message', () => {})
        clearInterval(this.state.intervalId)
        this.setState({intervalId: null})
    }

    updateZoomLevel = () => zoomLevel(this)

    getData = () => {
        this.setState({ loading: true }, () => {
            services
                .getServiceDashboardData()
                .then(({ status, data }) => {
                    if (status !== 200 || !status) return this.setState({errorWrap: true})
                    const { main_list, summary } = data
                    this.setState({ mainData: main_list })
                    this.setState({ summary })
                    this.setState({errorWrap: false})
                })
                .catch(error => {
                    console.log('error', error.response)
                    this.setState({errorWrap: true})
                    // errorFatalModal()
                })
                .finally(() => this.setState({ loading: false }))
        })
    }

    summaryWrap = () => {
        const { summary } = this.state
        return (
            <Col span={6}>
                <Card
                    title="סה״כ"
                    bordered={false}
                    headStyle={{ fontSize: '30px', textAlign: 'center' }}
                    className={card_style}
                >
                    {summary.map(({ title, status, count, color }) => {
                        return (
                            <div key={status} className={inner_div_style}>
                                <div className={title_style}>{title}</div>
                                <div style={{ color: `${color}` }} className={count_style}>
                                    {count}
                                </div>
                            </div>
                        )
                    })}
                </Card>
            </Col>
        )
    }

    mainDataWrap = () => {
        const { mainData } = this.state
        return mainData.map(({ service_option_id, statusCounts, option_name }) => {
            const isBC = statusCounts.length > 4 ? '33px' : '40px'
            const isBC2 = statusCounts.length > 4 ? '30px' : '36px'
            return (
                <Col span={6} key={service_option_id}>
                    <Card
                        title={option_name}
                        bordered={false}
                        headStyle={{ fontSize: '30px', textAlign: 'center' }}
                        className={card_style}
                    >
                        {statusCounts.map(({ title, count, color, idx }) => {
                            return (
                                <div key={idx} style={{ height: isBC }} className={inner_div_style}>
                                    <div className={title_style} style={{ lineHeight: isBC }}>
                                        {title}
                                    </div>
                                    <div style={{ color: `${color}`, lineHeight: isBC2 }} className={count_style}>
                                        {count}
                                    </div>
                                </div>
                            )
                        })}
                    </Card>
                </Col>
            )
        })
    }

    loader = () => {
        return (
            <div className={load_style}>
                <Spin size="large" />
            </div>
        )
    }

    errorWrapDiv = () => {
        return (
            <div className={error_wrap}>
                <div className={triangle}></div>
            </div>
        )
    }

    render() {
        const {
            mainDataWrap,
            summaryWrap,
            loader,
            errorWrapDiv,
            state: { zoomLevel, mainData, summary, loading, screenType, errorWrap }
        } = this
        const isShowCards = Boolean(mainData.length) && Boolean(summary.length)
        const zoom = screenType === 'mobile' ? mobileZoom() : zoomLevel

        return (
            <Row style={{ zoom }} className={main}>
                {errorWrap && errorWrapDiv()}
                {loading && loader()}
                {isShowCards && mainDataWrap()}
                {isShowCards && summaryWrap()}
            </Row>
        )
    }
}

export default UserServiceDashboard
